import { multiCompanySafeEnv } from '../env-utils';
export var LOG_LEVELS;
(function (LOG_LEVELS) {
    LOG_LEVELS["INFO"] = "INFO";
    LOG_LEVELS["DEBUG"] = "DEBUG";
    LOG_LEVELS["WARN"] = "WARN";
    LOG_LEVELS["ERROR"] = "ERROR";
    LOG_LEVELS["TRACE"] = "TRACE";
    LOG_LEVELS["FATAL"] = "FATAL";
})(LOG_LEVELS || (LOG_LEVELS = {}));
const _wrapper = {
    INFO: console.info,
    DEBUG: console.debug,
    WARN: console.warn,
    ERROR: console.error,
    TRACE: console.trace,
    FATAL: console.error,
};
const _LEVEL_PRIORITY = {
    TRACE: 1,
    DEBUG: 10,
    INFO: 20,
    WARN: 30,
    ERROR: 40,
    FATAL: 50,
};
const baseLevel = _LEVEL_PRIORITY[multiCompanySafeEnv({ key: 'CUSTOM_LAMBDA_LOGGER_LEVEL', fallbackValue: 'WARN' })];
const log = (level, ...args) => {
    const loggerLevel = _LEVEL_PRIORITY[level];
    if (loggerLevel < baseLevel)
        return;
    const fun = _wrapper[level];
    fun(...args);
};
// exports
const trace = (...args) => log('TRACE', ...args);
const debug = (...args) => log('DEBUG', ...args);
const info = (...args) => log('INFO', ...args);
const warn = (...args) => log('WARN', ...args);
const error = (...args) => log('ERROR', ...args);
const fatal = (...args) => log('FATAL', ...args);
export const Logger = {
    log: info,
    fatal,
    error,
    warn,
    info,
    debug,
    trace,
};
//# sourceMappingURL=logger.js.map